import * as PIXI from "pixi.js";
import { eventBus, EnumEventBus } from "../../EventBus";
import Panel from "../../../entities/Panel/Panel";
import SwitcherButton from "../../../../../../../src/entities/UI/SwitcherButton/SwitcherButton";
import DrawingToolsManagerFactory, { generateDrawingIcons, getHeader } from "./DrawingToolsManagerFactory";
import { DrawingTool } from "../../../types/Enum";
import { genButtonBounds } from "./helpers/getButtonBounds";
import ColorOptionCon from "../../../../../../../src/entities/UI/ColorOptionCon/ColorOptionCon";
import { genHandleFuncs } from "./helpers/getHandleFuncs";
import { colorOptEventBus, EnumColorOptEventBus } from "../../../../../../../src/entities/UI/ColorOptionCon/ColorOptEventBus";


export default class DrawingToolsManager extends PIXI.Container {
  private Panel = Panel.getInstance();
  private Buttons: { button: SwitcherButton, name: DrawingTool }[] = [];
  private ColorOptionCon = new ColorOptionCon({ x: 0, y: this.Panel.height - 40 }, 420);
  constructor() {
    super();
    this.addCoord();
    this.addHeader();
    this.addButtons();
    this.addToPanel();

    this.ColorOptionCon.addToCon(this.Panel);

    eventBus.on(EnumEventBus.startAnswer, (v: boolean) => this.setButtonDisabled(v));
    eventBus.on(EnumEventBus.showResults, () => this.setButtonDisabled(true, true));
    eventBus.on(EnumEventBus.setQuestMode, () => this.setButtonDisabled(false, true));
    colorOptEventBus.on(EnumColorOptEventBus.selectedColor, (color: number) => this.setIconColors(color));
  }

  private addToPanel = () => this.Panel.addChild(this);
  private addHeader = () => this.addChild(getHeader("Drawing Tools"));
  private addCoord = () => this.position.copyFrom({ x: 0, y: this.Panel.height - 180 });
  private setSelectedTool(toolName: DrawingTool) {
    this.Buttons.forEach(b => b.name !== toolName && b.button.handleDefaultPosition());

    toolName !== DrawingTool.ruler && eventBus.emit(EnumEventBus.showRuler, false);
    toolName !== DrawingTool.protractor && eventBus.emit(EnumEventBus.showProtractor, false)
    toolName !== DrawingTool.compass && eventBus.emit(EnumEventBus.showCompass, false);
  }
  private setButtonDisabled(v: boolean, forAll: boolean = false) {
    this.Buttons.forEach(b => {
      if (!forAll && (b.name === DrawingTool.clear || b.name === DrawingTool.returnBack)) { return }
      b.button.setDisabled(v);
    });
    forAll && this.ColorOptionCon.setAllDisabled(v);
  }
  private addButtons() {
    const icons = generateDrawingIcons();

    this.Buttons = icons.map((iconObj, iI) => {
      const bounds = genButtonBounds(iI)
      const isActiveButton = iconObj.name !== DrawingTool.clear && iconObj.name !== DrawingTool.returnBack;

      const { onHandleFunc, onHandleSecondFunc } = genHandleFuncs(iconObj.name, (toolName) => this.setSelectedTool(toolName));
      const toolButton = new SwitcherButton(bounds, iconObj.icon, isActiveButton, onHandleFunc, onHandleSecondFunc);

      this.addChild(toolButton);
      return { button: toolButton, name: iconObj.name };
    })
  }
  setIconColors(color: number) {
    this.Buttons.forEach(b => {
      const icon = b.button.icon as PIXI.Graphics;

      if (b.name == DrawingTool.point) DrawingToolsManagerFactory.drawPoint(icon, color)
      else if (b.name == DrawingTool.pencil) DrawingToolsManagerFactory.drawPencilIcon(icon, color)
      else if (b.name == DrawingTool.line) DrawingToolsManagerFactory.drawStandartLine(icon, color)
      else if (b.name == DrawingTool.compass) DrawingToolsManagerFactory.drawCompass(icon, color)

    })
  }
}